export const FILTERS_TITLES = {
  health_systems: 'Health system',
  hospitals: 'Hospital',
  led_by: 'Led by',
  user: 'User',
  contract_categories: 'Contract Category',
  portfolio: 'Portfolio'
}
